import React from "react";
import postgresqlLogo from "../../assets/platform-logos/postgres.png";
import googleSheetsLogo from "../../assets/platform-logos/googlesheet.png";
import sqliteLogo from "../../assets/platform-logos/sqlite.png";
import easyonLogo from "../../assets/platform-logos/easyon-logo.png";

const platforms = [
    { name: "PostgreSQL", logo: postgresqlLogo, position: "top-left" as const },
    { name: "Google Sheets", logo: googleSheetsLogo, position: "top-right" as const },
    { name: "SQLite", logo: sqliteLogo, position: "bottom" as const },
];

export const EasyonDatabasePlatformsVisual = () => (
    <div className="eo-db-platforms">
        <div className="eo-db-platforms__canvas" aria-hidden="true">
            <svg className="eo-db-platforms__lines" viewBox="0 0 400 280" preserveAspectRatio="none">
                <line x1="200" y1="118" x2="88" y2="72" />
                <line x1="200" y1="118" x2="312" y2="72" />
                <line x1="200" y1="132" x2="200" y2="208" />
            </svg>

            <div className="eo-db-platforms__hub">
                <img src={easyonLogo} alt="EasyOn" className="eo-db-platforms__hub-logo" />
            </div>

            {platforms.map((platform) => (
                <div key={platform.name} className={`eo-db-platforms__logo eo-db-platforms__logo--${platform.position}`}>
                    <img src={platform.logo} alt={platform.name} />
                    <span>{platform.name}</span>
                </div>
            ))}
        </div>

        <p className="eo-db-platforms__caption">
            Seamlessly integrates with the data platforms your business already uses.
        </p>
    </div>
);
